import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../environments/environment';
import {IOrder} from '../models/order.model';
import { KahpooOrangeSenegalPaymentInfo } from '../models/kahpooOrangeSenegalPaymentInfo.model';

@Injectable({
  providedIn: 'root'
})

export class OrangeService {

  constructor(private http: HttpClient) {}

  getTestNumber() {
    return this.http.get<any>(`${environment.url}/orange/testNumber`);
  }

  getRetailerBalance() {
    return this.http.get<any>(`${environment.url}/orange/retailerBalance`);
  }

  getRetailer() {
    return this.http.get<any>(`${environment.url}/orange/retailler`);
  }

  getEncryptedPinCode() {
    return this.http.get<any>(`${environment.url}/orange/encryptedPinCode`);
  }

  viewBalance() {
    return this.http.get<any>(`${environment.url}/sms/balance`);
  }

  sendSmsMessageSenegal(smsRequest:any) {
    return this.http.post<any>(`${environment.url}/sms  /sn/send`, smsRequest);
  }

  generateOTPCode(value: any) {
    return this.http.post<any>(`${environment.url}/orange/retrieve-otp`, value);
  }

  retailerBalance(retailer: any) {
    return this.http.post<any>(`${environment.url}/orange/retailerBalance`, retailer);
  }

  saveOrderByOrangeMoney(paymentInfo: KahpooOrangeSenegalPaymentInfo){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/orange/payWithOrange`, paymentInfo);
  }

}
